// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationOverflowContainerId } from './FermentationOverflowContainer';
import { fermentationTimepointId } from './FermentationTimepoint';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationOverflowWeightLogId = (z.number());
export const fermentationOverflowWeightLog = z.object({
    id: fermentationOverflowWeightLogId,
    overflow_container_id: fermentationOverflowContainerId,
    timepoint_id: fermentationTimepointId,
    container_weight_g: z.string().nullable(),
    sample_wet_g: z.string().nullable(),
    sample_dry_g: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentationOverflowWeightLogInitializer = z.object({
    id: fermentationOverflowWeightLogId.optional(),
    overflow_container_id: fermentationOverflowContainerId,
    timepoint_id: fermentationTimepointId,
    container_weight_g: z.string().optional().nullable(),
    sample_wet_g: z.string().optional().nullable(),
    sample_dry_g: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentationOverflowWeightLogMutator = z.object({
    id: fermentationOverflowWeightLogId.optional(),
    overflow_container_id: fermentationOverflowContainerId.optional(),
    timepoint_id: fermentationTimepointId.optional(),
    container_weight_g: z.string().optional().nullable(),
    sample_wet_g: z.string().optional().nullable(),
    sample_dry_g: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationOverflowWeightLog.js.map